import { Fragment, useEffect, useState } from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';

import { Collapse, Link, Stack, Tooltip } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { MenuListItem } from '@components/sidebar/components/menuListItem';

import { getPathWithoutParams } from '@utils/routes/getRoute';

import type { MenuExtendedItem } from '../types';
import { MenuSubItems } from './menuSubItems';

type MenuItemProps = {
  item: MenuExtendedItem;
  isCollapsed: boolean;
};

export const MenuItem = (props: MenuItemProps) => {
  const { item, isCollapsed } = props;
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const basePath = getPathWithoutParams(item?.route ?? '');
  let isActive = location.pathname.startsWith(basePath);

  const itemSx = {
    color: 'inherit',
    '&.active': {
      '& > .MuiListItem-root ': {
        background: (t: Theme) => t.palette.background.default,
        transition: '0.5s ease',
        color: (t: Theme) => t.palette.sidebar.light,
        borderRadius: '4px',
      },
    },
  };

  // для главной страницы отдельная проверка
  if (item.link === '/') {
    isActive = location.pathname === '/';
  }

  useEffect(() => {
    // если сайдбар схлопываем, то и сворачиваем подменю
    if (isCollapsed) {
      setOpen(false);
    }
  }, [isCollapsed]);

  return (
    <Fragment>
      <Tooltip
        arrow
        title={isCollapsed ? item.title : ''}
        placement="right"
      >
        {item.link ? (
          <Link
            component={RouterLink}
            underline="none"
            to={item.link}
            sx={itemSx}
            className={isActive ? 'active' : ''}
          >
            <MenuListItem
              item={item}
              isCollapsed={isCollapsed}
              isOpen={open}
              setOpen={setOpen}
            />
          </Link>
        ) : (
          <Stack
            sx={{ ...itemSx, cursor: 'pointer' }}
            onClick={item?.handleClick}
          >
            <MenuListItem
              item={item}
              isCollapsed={isCollapsed}
              isOpen={open}
              setOpen={setOpen}
            />
          </Stack>
        )}
      </Tooltip>

      {item.subItems && (
        <Collapse
          in={open}
          timeout="auto"
          unmountOnExit
        >
          <MenuSubItems items={item.subItems} />
        </Collapse>
      )}
    </Fragment>
  );
};
